import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Menu, X, Bell, Search, Settings, HelpCircle } from 'lucide-react';
import { useUserRoles } from '../../hooks/useUserRoles';
import { AppSidebar } from './AppSidebar';
import { AppHeader } from './AppHeader';
import { AppHelpTrigger } from '../help/AppHelpTrigger';

export const AppPortalLayout: React.FC = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { user, isLoading } = useUserRoles();

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Chargement du portail...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      {/* Mobile sidebar backdrop */}
      {sidebarOpen && (
        <div 
          className="fixed inset-0 z-40 bg-black bg-opacity-50 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Sidebar */}
      <AppSidebar 
        isOpen={sidebarOpen} 
        onClose={() => setSidebarOpen(false)} 
      />

      {/* Main content area */}
      <div className="lg:pl-64">
        {/* Header */}
        <AppHeader 
          onMenuClick={() => setSidebarOpen(true)}
          user={user}
        />

        {/* Main content */}
        <main className="py-6">
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <Outlet />
          </div>
        </main>
      </div>

      {/* Help trigger - floating button */}
      <AppHelpTrigger />
    </div>
  );
};
